import { LOCALE_ID } from '@angular/core';

import { MiddlewareSDK, SDK } from '@plugins/middleware-sdk';

export function localeIdProvider(availableLanguages: string[]) {
  return {
    provide: LOCALE_ID,
    deps: [SDK],
    useFactory: async (sdk: MiddlewareSDK) => {
      const { lang } = await sdk.getBrowserLanguage();
      if (availableLanguages.includes(lang)) {
        return lang;
      }
      return availableLanguages[0];
    },
  };
}
